export const constants = {
  NOT_VERIFIED_FUND_ACCOUNT_LIMIT: 1000,
  BONUS_TYPES: {
    OFF: null,
    DISCOUNT: 1,
    BONUS: 2,
    BROKER_FEES: 3
  },

  CONVERSION_STATUS: [
    {
      id: 'active',
      label: 'Active'
    },
    {
      id: 'inactive',
      label: 'Inactive'
    }
  ],

  ADSET_CONTENT_CATEGORY_STATUS: {
    ACTIVE: 1,
    INACTIVE: 2
  },

  CAMPAIGN_TYPES_IDS: {
    INLINE: 1,
    VIDEO: 3
  },

  CAMPAIGN_OBJECTIVES_IDS: {
    CONVERSION: 2,
    LEAD_FORM: 6,
    FACEBOOK_OUTCOME_TRAFFIC: 7,
    FACEBOOK_OUTCOME_CONVERSION_LEADS: 8,
    FACEBOOK_OUTCOME_CONVERSION_SALES: 9
  },

  ACCOUNT_VERIFICATION_STATUS: {
    VERIFIED: 'verified',
    PENDING: 'pending',
    UNVERIFIED: 'unverified'
  },

  PAYMENT_METHODS: {
    PAYPAL: 'Paypal',
    STRIPE: 'Stripe',
    PAYTABS:'Paytabs',
    CHECKOUT: 'Checkout',
    COMPENSATION: 'Compensation',
    BONUS: 'Bonus',
    BANK: 'Bank',
    CASH: 'Cash',
    CREDIT: 'Credit'
  },

  NOTIFICATIONS_SEVERITIES: {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error'
  },

  TRANSACTION_TYPES: {
    FUND: 2,
    VAT_CORRECTION: 4
  },

  TRACKING_TEST_STATUS: {
    DONE: 'done',
    PORCESSING: 'processing'
  },

  FEATURE_SHORTNAME: {
    FACEBOOK_ADVERTISING_CHANNEL:'facebook-advertising-channel'
  },

  CAMPAIGN_ADVERTISING_CHANNELS_NAMES: {
    FACEBOOK: 'Facebook'
  },

  CAMPAIGN_ADVERTISING_CHANNELS_IDS: {
    SPEAKOL: 1,
    FACEBOOK: 2
  },

  CAMPAIGN_OBJECTIVES_NAMES: {
    CONVERSIONS: 'Conversions',
    LEAD_FORM: 'Lead Form',
    APP_INSTALLS: 'App Installs',
    FACEBOOK_OUTCOME_CONVERSION_LEADS: 'FB Lead',
    FACEBOOK_OUTCOME_CONVERSION_SALES: 'FB Sales'
  },

  CAMPAIGN_TYPES_NAMES: {
    INLINE: 'Inline',
    RECOMMENDATIONS: 'Recommendations',
    VIDEO: 'Video',
    SINGLE_IMAGE: 'Single Image'
  },

  DEVICES_TYPES: {
    1: 'desktop',
    2: 'ios',
    3: 'android'
  },

  DEVICES_IDS: {
    DESKTOP: 1,
    IOS: 2,
    ANDROID: 3,
    TABLET: 4
  },

  ANALYTICS_EVENTS_NAMES: {
    LEADS: 'leads'
  },

  ONBOARDING_NOTIFICATIONS_TAGS: [
    'connection_intro',
    'lead_form_intro'
  ],

  LANGUAGES: {
    EN: 1,
    AR: 2
  },

  IMAGES_REVIEW_REASONS_IDS: [1, 2, 3, 4, 5, 6],
  VIDEOS_REVIEW_REASONS_IDS: [1, 2, 4, 5, 7, 8],

  AD_REVIEW_REASON_TYPE_IDS: {
    REJECT: 0,
    HOLD: 1
  },

  AD_ACCEPTANCE_STATUSES: {
    REJECTED: 0,
    ACCEPTED: 1,
    ON_HOLD: 2,
    UNDER_REVIEW: null
  },

  FEEDBACK_TYPES: {
    REJECT: 0,
    HOLD: 1
  },

  RECOMMENDATION_ITEM_STATUS: {
    PENDING: 0,
    APPLIED: 1
  },

  HTTP_STATUS_CODES: {
    UNAUTHORIZED: 401,
    PRECONDITION_FAILED: 412,
    CSRF_TOKEN_EXPIRED: 419,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503
  },

  CROPPER_STATUS: {
    APPLIED: 'applied',
    CANCELED: 'canceled'
  },

  LEAD_FORM_PRIMITIVE_QUESTIONS: ['full_name', 'email', 'phone_number', 'whatsapp_number'],

  LEAD_FORM_ANSWER_TYPES:[
    {
      value: 'short',
      text: 'Short Answer',
      icon: 'speakol-short-answer'
    },
    {
      value: 'multiple',
      text: 'Multiple Choice',
      icon: 'speakol-multiple-choice'
    }
  ]
}
